module.exports = __webpack_public_path__ + "img/software-upload.952b1967.svg";